import React, { useEffect, useState } from "react";
import { Intent } from "@blueprintjs/core";
import { Button, ButtonSave } from "components/buttons";
import { FormTextArea } from "components/form-fields";
import {
    AlertUnsavedData,
    NotificationToaster,
} from "components/notifications";
import { AlertService } from "services";
import PropTypes from "prop-types";

export function CommentModal({
    alert = null,
    close = () => {},
    save = () => {}
}) {
    const [isDirty, setIsDirty] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [comment, setComment] = useState("");

    useEffect(() => {
        if (alert) {
            setComment(alert.comment);
        }
    }, [alert]);

    function cancelModal() {
        if (alert.comment !== comment) {
            setIsDirty(true);
        } else {
            close();
        }
    }

    function saveComment() {
        setIsSaving(true);
        AlertService.saveComment(alert.alertId, comment)
            .then(
                () => {
                    NotificationToaster.show(
                        Intent.SUCCESS,
                        "Comment saved successfully."
                    );
                    save();
                },
                () => {
                    NotificationToaster.show(
                        Intent.DANGER,
                        "Unable to save comment. Please try again."
                    );
                }
            )
            .catch(() => {
                NotificationToaster.show(
                    Intent.DANGER,
                    "Unable to save comment. Please try again."
                );
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return (
        <>
            <FormTextArea
                id="comment-text-area"
                value={comment}
                onChange={(e) => {
                    setComment(e.target.value);
                }}
                maxLength={1000}
                disabled={isSaving}
                showCounter
            />

            <div className="bp6-dialog-footer">
                <div className="bp6-dialog-footer-actions">
                    <ButtonSave
                        id="comment-save"
                        onClick={saveComment}
                        disabled={isSaving}
                    />
                    <Button
                        text="Cancel"
                        intent="secondary"
                        onClick={cancelModal}
                        disabled={isSaving}
                    />
                </div>
            </div>

            <AlertUnsavedData
                isDirtySamePage={isDirty}
                onConfirmLeave={close}
                onCancelLeave={() => setIsDirty(false)}
            ></AlertUnsavedData>
        </>
    );
}

CommentModal.propTypes = {
    alert: PropTypes.object,
    close: PropTypes.func,
    save: PropTypes.func,
};
